<template>
  <div class="pregled-vsebine">
    <div class="postavitev-izbirnika">
      <div class="izbirnik-stranke">
        <div>
          <IzbirnikStranke v-on:osvezitevIzbranSap="GetSap" />
        </div>
      </div>
      <div style="clear: both"/>
    </div>
    <div class="vsebina-postavitev">
      <div class="odmik-vsebine ">
        <div>
          <p class="open-sans-30pt">
            Nastavitve telefonije
          </p>
        </div>
        <div style="padding-top: 20px; padding-bottom: 15px">
          <div style="padding-top: 5px">
            <div>
              <span class="izbirnik-odmik-zgoraj">
                Izberite številko
              </span>
              <el-select
                ref="telefonSelect"
                value-key="telefonska_stevilka"
                v-model="izbranaTelefonska"
                placeholder="Izberite tel. številko"
                class="postavitev-izbirnika-stevilke"
                :disabled="pogrupiraneTelStevilke.length === 0"
                :default-first-option="false"
                filterable
                :filter-method="onQueryChange"
                @input="onSelectInput"
                @visible-change="onDropdownVisibleChange">
                <el-option-group
                  v-for="grupa in filtriraneSkupine"
                  :key="grupa.label"
                  :label="grupa.label">
                  <el-option
                    v-for="(data, key) in grupa.seznamTelStevilk"
                    :value="data"
                    :key="key"
                    :label="VrniFormatiranoTelefonsko(data.telefonska_stevilka, data.tip_stevilke)">
                  </el-option>
                </el-option-group>
              </el-select>
          </div>
        </div>
      </div>
      <div style="clear: both"/>
        <div>
          <div class="obvestilo-prazen-seznam" v-if="this.izbranaTelefonska === null && pridobivanjeStevilk">
            <p>
              Nastavitve telefonije so na voljo samo za izbrane številke, zato nastavitev na vaših naročenih
              številkah trenutno ne morete upravljati. Za več informacij o možnostih upravljanja se obrnite na
              poslovnega skrbnika, ki vam bo pomagal poiskati ustrezno rešitev.
            </p>
          </div>
          <div class="obvestilo-prazen-seznam"
               v-if="this.izbranaTelefonska !== null && this.izbranaTelefonska.neupravljiva && pridobivanjeStevilk">
            <p>
              Nastavitve telefonije niso na voljo za to vrsto številke, zato nastavitev na izbrani številki trenutno
              ni mogoče urejati. Za več informacij o možnostih upravljanja se obrnite na svojega poslovnega
              skrbnika, ki vam bo pomagal poiskati ustrezno rešitev.
            </p>
          </div>
          <div v-if="this.izbranaTelefonska !== null && !this.izbranaTelefonska.neupravljiva && pridobivanjeStevilk">
            <div v-if="jeStacionarnaTelefonija  === true" style="clear: both; padding-top: 15px">
              <el-tabs type="border-card" class="tabs-cont" v-model="activetab">
                <el-tab-pane label="Preusmeritve" name="t1">
                  <PreusmeritevStacionarnaTelefonija
                    :izbranPrikljucek="izbranaTelefonska.id_prikljucek"
                    :izbranaTelefonska="izbranaTelefonska.telefonska_stevilka"
                    :ims-stevilka="izbranaTelefonska.tip_ims === '1'"
                    :jeStatusOdzivnika="jeStatusOdzivnika"/>
                </el-tab-pane>
                <el-tab-pane label="Telefonski odzivnik" name="t2">
                  <TelefonskiOdzivnik
                    :key="odzivnikKey"
                    :izbranPrikljucek="izbranaTelefonska.id_prikljucek"
                    :izbranaTelefonska="izbranaTelefonska.telefonska_stevilka"
                    v-on:jeStatusOdzivnika="PridobljenStatusOdzivnika"/>
                </el-tab-pane>
                <el-tab-pane label="Blokade klicev" name="t3">
                  <BlokadeKlicov
                    :izbranPrikljucek="izbranaTelefonska.id_prikljucek"
                    :izbranaTelefonska="izbranaTelefonska.telefonska_stevilka"/>
                </el-tab-pane>
                <el-tab-pane label="Objava številke" name="t4">
                  <ObjavaStevilke  :izbranPrikljucek="izbranaTelefonska.id_prikljucek"
                                   :izbranaTelefonska="izbranaTelefonska.telefonska_stevilka"/>
                </el-tab-pane>
              </el-tabs>
            </div>
            <div v-else style="padding-top: 15px">
              <el-tabs type="border-card" class="tabs-cont" v-model="activetab">
                <el-tab-pane label="Nastavitve SIM" name="t1">
                  <PodatkiSim
                    v-if="podatkiOsim !== null"
                    :izbranPrikljucek="izbranaTelefonska.id_prikljucek"
                    :izbranaTelefonska="izbranaTelefonska.telefonska_stevilka"
                    :prenosniPodatkiMoznostSMSDeblokade="prenosniPodatkiMoznostSMSDeblokade"
                    v-on:spremebaSmSDeblokade="NastaviMoznostDeblokadeSMS"
                    :prenosniPodatkiUmtsObvescanje="prenosniPodatkiUmtsObvescanje"
                    :privzetaVrednost="privzetaVrednost"
                    v-on:spremembaObvescanjeTujina="SprememebaInformativnoObvescanjeTujina"
                    :podatkiOsim="podatkiOsim"/>
                </el-tab-pane>
                <el-tab-pane label="Blokade" name="t2">
                  <Blokade
                    v-if="!jeStacionarnaTelefonija && activetab === 't2'"
                    :id-sim-kartice="podatkiOsim.idSimKartica"
                    :voiceFeaturesEnabled="voiceFeaturesEnabled"
                    :izbranPrikljucek="izbranaTelefonska.id_prikljucek"
                    :izbranaTelefonska="izbranaTelefonska.telefonska_stevilka"
                    :jeMobilniTopPaket="jeMobilniTopPaket"
                  />
                </el-tab-pane>
                <el-tab-pane label="Nastavitev APN točke" name="t3">
                  <NastavitevApnTock
                    v-if="!jeStacionarnaTelefonija && activetab === 't3'"
                    :izbranPrikljucek="izbranaTelefonska.id_prikljucek"
                    :izbranaTelefonska="izbranaTelefonska.telefonska_stevilka"
                  />
                </el-tab-pane>
                <el-tab-pane label="Preusmeritve" v-if="voiceFeaturesEnabled" name="t4">
                  <PreusmeritevMobilnaTelefonija
                    v-if="podatkiOsim !== null && !jeStacionarnaTelefonija && activetab === 't4'"
                    :podatki-o-sim="podatkiOsim"
                    :izbranPrikljucek="izbranaTelefonska.id_prikljucek"
                    :izbranaTelefonska="izbranaTelefonska.telefonska_stevilka"
                    :sap="izbranaTelefonska.sap"
                  />
                </el-tab-pane>
                <el-tab-pane label="Seznam roaming držav" name="t5">
                  <SeznamRoamingDrzav v-if="!jeStacionarnaTelefonija && activetab === 't5'" />
                </el-tab-pane>
                <el-tab-pane label="Objava številke" v-if="voiceFeaturesEnabled" name="t6">
                  <ObjavaStevilke
                    v-if="!jeStacionarnaTelefonija && activetab === 't6'"
                    :izbranPrikljucek="izbranaTelefonska.id_prikljucek"
                    :izbranaTelefonska="izbranaTelefonska.telefonska_stevilka"
                  />
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import NastavitevApnTock from './NastavitveTelefonije/NastavitveMobilnaTelefonija/NastavitevApnTock'
import PreusmeritevMobilnaTelefonija
  from './NastavitveTelefonije/NastavitveMobilnaTelefonija/PreusmeritevMobilnaTelefonija'
import Blokade from './NastavitveTelefonije/NastavitveMobilnaTelefonija/Blokade'
import PodatkiSim from './NastavitveTelefonije/NastavitveMobilnaTelefonija/PodatkiSim'
import TelefonskiOdzivnik from './NastavitveTelefonije/NastavitveStacionarnaTelefonija/TelefonskiOdzivnik.vue'
import PreusmeritevStacionarnaTelefonija
  from './NastavitveTelefonije/NastavitveStacionarnaTelefonija/PreusmeritevStacionarnaTelefonija'
import BlokadeKlicov from './NastavitveTelefonije/NastavitveStacionarnaTelefonija/BlokadeKlicov'
import SeznamRoamingDrzav from './NastavitveTelefonije/NastavitveMobilnaTelefonija/SeznamRoamingDrzav'
import IzbirnikStranke from '../GlobalneKomponente/IzbirnikStranke.vue'
import {Tabs, TabPane, Checkbox, Button, Select, Option, Input, MessageBox, OptionGroup} from 'element-ui'
import ClientAgent from '../../../../assets/js/clientAgent.js'
import ObjavaStevilke from './NastavitveTelefonije/ObjavaStevilke'
import {FormatirajTelefonskoStevilko}
  from '../../../../assets/js/globalne_funkcije/GlobalnoTelefonija/FormatTelefonskeStevilke.js'
import {PrikljucekStatusEnum} from '../../../../assets/js/Enum/PrikljucekStatusEnum'
import {TipStevilkeEnum} from '../../../../assets/js/Enum/TipStevilkeEnum'

/** Napaka pravice NASTAVITVE_TELEFONIJA (oauth.permissions.no_result_error), ko stranka nima upravljive številke */
const NI_UPRAVLJIVIH_STEVILK = 'Nimate pravice za to telefonsko številko'

export default {
  Name: 'NastavitveTelefonija',
  mixins: [FormatirajTelefonskoStevilko],
  data () {
    return {
      jeStacionarnaTelefonija: false,
      jeMobilniTopPaket: false,
      activetab: 't1',
      seznamTelStevilk: [],
      upravljiveTelStevilke: [],
      izbranaTelefonska: null,
      prenosniPodatkiMoznostSMSDeblokade: [],
      podatkiOsim: null,
      prenosniPodatkiUmtsObvescanje: [],
      privzetaVrednost: '',
      jeStatusOdzivnika: '',
      pridobivanjePodatkov: true,
      pridobivanjeStevilk: false,
      veljavniStatusZaPrikaz: [],
      pogrupiraneTelStevilke: [],
      seznamPrikljuckov: [],
      voiceFeaturesEnabled: true,
      izbranSap: '',
      stacinarniTipiStevilk: [TipStevilkeEnum.NI_DOLOCENO, TipStevilkeEnum.TELEFON, TipStevilkeEnum.ALARM],
      iskalniNiz: '',
      odzivnikKey: 0
    }
  },
  components: {
    ObjavaStevilke,
    SeznamRoamingDrzav,
    PodatkiSim,
    'NastavitevApnTock': NastavitevApnTock,
    'Blokade': Blokade,
    'PreusmeritevMobilnaTelefonija': PreusmeritevMobilnaTelefonija,
    'PreusmeritevStacionarnaTelefonija': PreusmeritevStacionarnaTelefonija,
    'BlokadeKlicov': BlokadeKlicov,
    'TelefonskiOdzivnik': TelefonskiOdzivnik,
    'IzbirnikStranke': IzbirnikStranke,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [Select.name]: Select,
    [Option.name]: Option,
    [OptionGroup.name]: OptionGroup,
    [TabPane.name]: TabPane,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [Select.name]: Select,
    [Option.name]: Option,
    [Input.name]: Input
  },
  mounted () {
    this.veljavniStatusZaPrikaz = [
      PrikljucekStatusEnum.VKLOPLJEN
    ]
    this.clientAgent = new ClientAgent()
  },
  computed: {
    filtriraneSkupine () {
      const normaliziraj = str => str.replace(/[\s+()-]/g, '').toLowerCase()
      const poizvedba = normaliziraj(this.iskalniNiz)
      if (!poizvedba) {
        return this.pogrupiraneTelStevilke
      }
      return this.pogrupiraneTelStevilke
        .map(group => {
          const filtriraneStevilke = group.seznamTelStevilk.filter(item =>
            normaliziraj(item.telefonska_stevilka).toLowerCase().includes(poizvedba)
          )

          return {
            label: group.label,
            seznamTelStevilk: filtriraneStevilke
          }
        })
        .filter(group => group.seznamTelStevilk.length > 0)
    }
  },
  watch: {
    izbranaTelefonska () {
      // za neupravljivo številko se pokaže samo obvestilo, brez klicev za nastavitve
      if (this.izbranaTelefonska !== null && !this.izbranaTelefonska.neupravljiva) {
        this.podatkiOsim = null
        this.StacionarnaAliMobilnaTelSt()
      }
    }
  },
  methods: {
    async GetSap (izbranSap) {
      if (izbranSap !== '') {
        this.izbranSap = izbranSap
        this.podatkiOsim = null
        await this.GetPrikljuckiDovoljenja(izbranSap)
        this.GetStevilke(izbranSap)
      }
    },
    async GetPrikljuckiDovoljenja (sap) {
      try {
        let resp = await this.clientAgent.makeRequest(
          'permissions/all',
          {permissions: ['PRIKLJUCKI']}
        )
        await this.SetPrikljuckiDovoljenja(resp)
      } catch (e) {
        this.ErrPrikljuckiDovoljenja(e)
      }
    },
    SetPrikljuckiDovoljenja (podatki) {
      this.seznamPrikljuckov = podatki.results.PRIKLJUCKI.additionalData
    },
    ErrPrikljuckiDovoljenja (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
    },
    GetStevilke (sap) {
      // najprej upravljive številke, nato vse (NASTAVITVE_TELEFONIJA_PRIKAZ), da se v izbirniku pokažejo tudi
      // neupravljive (TIS, Odzivnik, trunk ...) z obvestilom (#240208)
      this.upravljiveTelStevilke = []
      let param = ['permissionId=NASTAVITVE_TELEFONIJA']
      param.push('filter[sap]=' + sap)
      this.clientAgent.postWsRequest(
        this,
        'permissions/havePermission',
        param,
        null,
        'SetUpravljiveStevilke',
        'ErrUpravljiveStevilke')
    },
    SetUpravljiveStevilke (podatki) {
      this.upravljiveTelStevilke = podatki.permission.additionalData
      this.GetVseStevilke()
    },
    ErrUpravljiveStevilke (podatki) {
      this.upravljiveTelStevilke = []
      // brez upravljivih številk zadostujejo neupravljive v izbirniku oz. obvestilo na strani
      if (podatki.message !== NI_UPRAVLJIVIH_STEVILK) {
        let paramObvestilo = {}
        paramObvestilo.message = podatki.message
        this.ShowWarningMessage(paramObvestilo)
      }
      this.GetVseStevilke()
    },
    GetVseStevilke () {
      let param = ['permissionId=NASTAVITVE_TELEFONIJA_PRIKAZ']
      param.push('filter[sap]=' + this.izbranSap)
      this.clientAgent.postWsRequest(
        this,
        'permissions/havePermission',
        param,
        null,
        'SetVseStevilke',
        'ErrVseStevilke')
    },
    SetVseStevilke (podatki) {
      let upravljive = new Set(this.upravljiveTelStevilke.map(x => x.telefonska_stevilka))
      let neupravljive = podatki.permission.additionalData
        .filter(x => !upravljive.has(x.telefonska_stevilka))
        .map(x => Object.assign({}, x, {neupravljiva: true}))
      this.SetStevilkePrikljucka(this.upravljiveTelStevilke.concat(neupravljive))
    },
    ErrVseStevilke () {
      // npr. deljena pravica NASTAVITVE_TELEFONIJA brez pravice za prikaz: samo upravljive številke
      this.SetStevilkePrikljucka(this.upravljiveTelStevilke)
    },
    SetStevilkePrikljucka (seznamStevilk) {
      this.pogrupiraneTelStevilke = []
      this.izbranaTelefonska = null
      this.seznamTelStevilk = seznamStevilk
      this.seznamTelStevilk.forEach(stevilka => {
        if (!this.seznamPrikljuckov.find(
          x => x.id_stranka_sap === this.izbranSap) &&
          stevilka.selector_id === this.izbranSap) {
          let najdenaSkupina = this.pogrupiraneTelStevilke.find(x => x.label === 'Priključki s pravico')
          if (!najdenaSkupina) {
            this.pogrupiraneTelStevilke.push({'seznamTelStevilk': [stevilka], 'label': 'Priključki s pravico'})
          } else if (!najdenaSkupina.seznamTelStevilk.includes(stevilka)) {
            najdenaSkupina.seznamTelStevilk.push(stevilka)
          }
        } else {
          this.seznamPrikljuckov.forEach(prikljucek => {
            if (stevilka.id_prikljucek === prikljucek.id_prikljucek && stevilka.selector_id === this.izbranSap) {
              if (stevilka.tip_stevilke === TipStevilkeEnum.UMTS && this.izbranaTelefonska === null) {
                this.izbranaTelefonska = stevilka
              }
              let groupa = stevilka.stacionarna_stevilka === '1' ? prikljucek.naslov : 'Mobilni priključki'
              let najdenaSkupina = this.pogrupiraneTelStevilke.find(x => x.label === groupa)
              if (najdenaSkupina === undefined) {
                this.pogrupiraneTelStevilke.push({'seznamTelStevilk': [stevilka], 'label': groupa})
              } else if (!najdenaSkupina.seznamTelStevilk.includes(stevilka)) {
                najdenaSkupina.seznamTelStevilk.push(stevilka)
              }
            }
          })
        }
      })
      if (this.pogrupiraneTelStevilke.length > 0 && this.izbranaTelefonska === null) {
        // privzeto upravljiva številka, neupravljiva samo, če drugih ni
        let vse = this.pogrupiraneTelStevilke.flatMap(x => x.seznamTelStevilk)
        this.izbranaTelefonska = vse.find(x => !x.neupravljiva) || vse[0]
      }
      this.pogrupiraneTelStevilke.sort(function (a, b) {
        if (a.label === 'Mobilni priključki') {
          return -1
        } else if (b.label === 'Mobilni priključki') {
          return 1
        } else return a.label < b.label ? -1 : a.label > b.label ? 1 : 0
      })
      this.pridobivanjeStevilk = true
    },
    StacionarnaAliMobilnaTelSt () {
      this.voiceFeaturesEnabled = true
      for (let tel of this.seznamTelStevilk) {
        if (tel.telefonska_stevilka !== this.izbranaTelefonska.telefonska_stevilka) {
          continue
        }
        if (tel.voice_features_enabled === '1') {
          this.voiceFeaturesEnabled = true
        } else if (tel.voice_features_enabled === '0') {
          this.voiceFeaturesEnabled = false
        }
        this.jeMobilniTopPaket = tel.mobilni_top_paket === '1'
        if (this.stacinarniTipiStevilk.includes(tel.tip_stevilke) &&
          tel.stacionarna_stevilka === '1') {
          this.jeStacionarnaTelefonija = true
          this.odzivnikKey++
        } else if ([TipStevilkeEnum.UMTS, TipStevilkeEnum.ALARM].includes(tel.tip_stevilke)) {
          this.jeStacionarnaTelefonija = false
          this.GetMoznostSMSDeblokade()
          this.GetNaborCasovnihIzbir()
          this.PridobiPodatkeSim()
          this.GetUmtsGostovanjeObvescanje()
        }
        break
      }
    },
    PridobljenStatusOdzivnika (status) {
      this.jeStatusOdzivnika = ''
      this.jeStatusOdzivnika = status
    },
    GetUmtsGostovanjeObvescanje () {
      if (this.izbranaTelefonska !== null) {
        let param = ['idPrikljucek=' + this.izbranaTelefonska.id_prikljucek]
        param.push('stevilka=' + this.izbranaTelefonska.telefonska_stevilka)
        this.clientAgent.postWsRequest(this,
          'prikljucek/telefonija/umts/pridobiUmtsGostovanjeObvescanje?',
          param,
          null,
          'SetUmtsGostovanjeObvescanje',
          'ErrUmtsGostovanjeObvescanje')
      }
    },
    SetUmtsGostovanjeObvescanje (podatki) {
      this.prenosniPodatkiUmtsObvescanje = podatki.data
      this.privzetaVrednost = ''
      let infoData = podatki.data.info
      for (let i = 0; i < infoData.length; i++) {
        if (infoData[i].vkljuceno === true) {
          this.privzetaVrednost = infoData[i]
        }
      }
    },
    ErrUmtsGostovanjeObvescanje (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
    },
    SprememebaInformativnoObvescanjeTujina (idUmtsGostovanjeObvescanje) {
      this.prenosniPodatkiUmtsObvescanje = null
      if (this.izbranaTelefonska !== null && idUmtsGostovanjeObvescanje === 2) {
        MessageBox.confirm(
          'Ali ste prepričani, da želite spremeniti obveščanje ?', {
            confirmButtonText: 'Da',
            cancelButtonText: 'Prekliči',
            confirmButtonClass: 'gumb-potrdi',
            cancelButtonClass: 'gumb-preklici',
            customClass: 'opozorilo-dialog'
          }).then(() => {
          this.SproziSprememboObvescanja(idUmtsGostovanjeObvescanje)
          this.prenosniPodatkiUmtsObvescanje = 2
        }).catch((err) => {
          err = null
          this.prenosniPodatkiUmtsObvescanje = 1
        })
      }
      if (this.izbranaTelefonska !== null && idUmtsGostovanjeObvescanje === 1) {
        MessageBox.confirm('Ste prepričani, da želite izključiti informativno obveščanje v tujini?', {
          confirmButtonText: 'Da',
          confirmButtonClass: 'gumb-potrdi',
          cancelButtonText: 'Prekliči',
          cancelButtonClass: 'gumb-preklici',
          customClass: 'opozorilo-dialog'
        }).then(() => {
          this.SproziSprememboObvescanja(idUmtsGostovanjeObvescanje)
          this.prenosniPodatkiUmtsObvescanje = 1
        }).catch((err) => {
          err = null
          this.prenosniPodatkiUmtsObvescanje = 2
        })
      }
    },
    SproziSprememboObvescanja (idUmtsGostovanjeObvescanje) {
      let param = ['idPrikljucek=' + this.izbranaTelefonska.id_prikljucek]
      param.push('stevilka=' + this.izbranaTelefonska.telefonska_stevilka)
      param.push('idUmtsGostovanjeObvescanje=' + idUmtsGostovanjeObvescanje)
      this.clientAgent.postWsRequest(this,
        'prikljucek/telefonija/umts/shraniUmtsGostovanjeObvescanje?',
        param,
        null,
        'SetSprememebaInformativnoObvescanjeTujina',
        'ErrSprememebaInformativnoObvescanjeTujina')
    },
    SetSprememebaInformativnoObvescanjeTujina () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Uspešno spremenjeno obveščanje v tujini.'
      this.ShowSuccessMessage(paramObvestilo)
      this.GetUmtsGostovanjeObvescanje()
    },
    ErrSprememebaInformativnoObvescanjeTujina (podatki) {
      this.ShowWarningMessage(podatki)
    },
    GetMoznostSMSDeblokade () {
      if (this.izbranaTelefonska !== null && this.izbranaTelefonska !== null) {
        let param = ['idPrikljucek=' + this.izbranaTelefonska.id_prikljucek]
        param.push('stevilka=' + this.izbranaTelefonska.telefonska_stevilka)
        this.clientAgent.postWsRequest(this,
          'prikljucek/telefonija/umts/pridobiMoznostSMSDeblokade?',
          param,
          null,
          'SetMoznostSMSDeblokade',
          'ErrMoznostSMSDeblokade')
      }
    },
    SetMoznostSMSDeblokade (podatki) {
      this.prenosniPodatkiMoznostSMSDeblokade = podatki.data
    },
    ErrMoznostSMSDeblokade (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
    },
    NastaviMoznostDeblokadeSMS (statusDeblokadeSms) {
      if (this.izbranaTelefonska !== null) {
        let textGumb = `Da, želim ${statusDeblokadeSms === 'off' ? 'izključiti' : 'vključiti'} deblokado`
        let tekstOpozorilo = `Ste prepričani, da želite ${
          statusDeblokadeSms === 'off'
            ? 'izključiti možnost deblokade podatkovnega prometa preko SMS sporočila?'
            : 'vključiti deblokado podatkovnega prometa prek SMS sporočila?' +
            ' Če je ta možnost omogočena, bo uporabnik lahko nadaljeval s porabo podatkovnega prometa.'
        }`
        MessageBox.confirm(
          tekstOpozorilo,
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: textGumb,
            confirmButtonClass: 'gumb-potrdi',
            cancelButtonText: 'Prekliči',
            cancelButtonClass: 'gumb-preklici',
            customClass: 'opozorilo-dialog'
          }).then(() => {
          this.OmogociDeblokadoSMS(statusDeblokadeSms)
        }).catch((err) => {
          err = null
          this.prenosniPodatkiMoznostSMSDeblokade.status =
            this.prenosniPodatkiMoznostSMSDeblokade.status === 'on' ? 'off' : 'on'
        })
      } else {
        this.OmogociDeblokadoSMS(statusDeblokadeSms)
      }
    },
    OmogociDeblokadoSMS (statusDeblokadeSms) {
      let param = ['idPrikljucek=' + this.izbranaTelefonska.id_prikljucek]
      param.push('stevilka=' + this.izbranaTelefonska.telefonska_stevilka)
      param.push('moznostSmsDeblokade=' + statusDeblokadeSms)
      this.clientAgent.postWsRequest(this,
        'prikljucek/telefonija/umts/nastaviMoznostDeblokadeSMS?',
        param,
        null,
        'SetNastaviMoznostDeblokadeSMS',
        'ErrNastaviMoznostDeblokadeSMS')
    },
    SetNastaviMoznostDeblokadeSMS () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Uspešno nastavljena možnost deblokade preko SMS.'
      this.ShowSuccessMessage(paramObvestilo)
    },
    ErrNastaviMoznostDeblokadeSMS (podatki) {
      this.ShowWarningMessage(podatki)
    },
    GetNaborCasovnihIzbir () {
      if (this.izbranaTelefonska !== null) {
        let param = []
        this.clientAgent.postWsRequest(this,
          'prikljucek/telefonija/umts/pridobiNaborCasovnihIzbir?',
          param,
          null,
          'SetNaborCasovnihIzbir',
          'ErrNaborCasovnihIzbir')
      }
    },
    SetNaborCasovnihIzbir (podatki) {
      this.seznamCasovnihIzbir = podatki.data
    },
    ErrNaborCasovnihIzbir (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
    },
    PridobiPodatkeSim () {
      if (this.izbranaTelefonska !== null && this.izbranaTelefonska !== null) {
        let param = ['idPrikljucek=' + this.izbranaTelefonska.id_prikljucek]
        param.push('stevilka=' + this.izbranaTelefonska.telefonska_stevilka)
        this.clientAgent.postWsRequest(this,
          'prikljucek/telefonija/umts/pridobiPodatkeSim?',
          param,
          null,
          'SetPridobiPodatkeSim',
          'ErrPridobiPodatkeSim')
      }
    },
    SetPridobiPodatkeSim (podatki) {
      this.podatkiOsim = podatki.data
    },
    ErrPridobiPodatkeSim (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
    }
  }
}
</script>
<style scoped src="../../../../../static/css/Nastavitve/Telefonija/NastavitveTelefonija.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Nastavitve/NastavitveTelefonija.vue